import { render, staticRenderFns } from "./Block6.vue?vue&type=template&id=4c07ce39&scoped=true"
import script from "./Block6.vue?vue&type=script&lang=js"
export * from "./Block6.vue?vue&type=script&lang=js"
import style0 from "./Block6.vue?vue&type=style&index=0&id=4c07ce39&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07ce39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c07ce39')) {
      api.createRecord('4c07ce39', component.options)
    } else {
      api.reload('4c07ce39', component.options)
    }
    module.hot.accept("./Block6.vue?vue&type=template&id=4c07ce39&scoped=true", function () {
      api.rerender('4c07ce39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block6.vue"
export default component.exports